import {UmpireImage} from '../umpire-image';
import {UmpireQuiz} from '../umpire-quiz';
import {UmpireQuizAnswer} from '../umpire-quiz-answer';

export interface UmpireQuizQuestion {
  id: string | null;

  type: 'quiz_question';

  content: string | null;

  image: Partial<UmpireImage> | null;

  quiz_answers: UmpireQuizAnswer[];

  quiz: Partial<UmpireQuiz>;

  slug: string | null;
}
